import { useState } from 'react';
import { ReactComponent as MailboxIcon } from '../../icons/mailbox.svg';
import './Register.scss';
import WhiteGreenWrapper from '../../wrappers/WhiteGreenWrapper';
import RegisterForm, { RegisterStepType } from './RegisterForm';
import Header from '../../components/Header/Header';

import { ReactComponent as CreateAccountIconEN } from '../../images/create_account_en.svg';
import { ReactComponent as CreateAccountIconDE } from '../../images/create_account_de.svg';
import { useTranslation } from 'react-i18next';

const HEADER_BLOCK_KEY = 'header';

interface Props {
  initialStep?: RegisterStepType;
  initialEmail?: string;
  initialPassword?: string;
}

export default function Register({
  initialStep,
  initialEmail,
  initialPassword,
}: Props) {
  const { i18n, t } = useTranslation();
  const [isMailboxIconShown, setIsMailboxIconShown] = useState(
    initialStep === 'verify_email'
  );
  const onStepChange = () => {
    setIsMailboxIconShown(true);
  };

  return (
    <>
      <Header blockKey={HEADER_BLOCK_KEY} />
      <WhiteGreenWrapper
        className='WhiteGreenWrapper--Register'
        rightSideContent={
          isMailboxIconShown ? (
            <div className='d-flex align-items-center justify-content-center'>
              <MailboxIcon className='Register__mailboxImage mt-5 pt-5 mb-5 pb-3 w-100 mx-auto' />
            </div>
          ) : (
            <div>
              <div
                className='Text mb-4 pb-2 text-center'
                dangerouslySetInnerHTML={{
                  __html: t(
                    'Get a detailed overview of your cross-border sales, storage, and get recommendations for a compliant VAT setup'
                  ),
                }}
              />
              <div className='Register__imageContainer'>
                {i18n.language === 'en' ? (
                  <CreateAccountIconEN />
                ) : (
                  <CreateAccountIconDE />
                )}
              </div>
            </div>
          )
        }
      >
        <RegisterForm
          onStepChange={onStepChange}
          initialStep={initialStep}
          initialEmail={initialEmail}
          initialPassword={initialPassword}
        />
      </WhiteGreenWrapper>
    </>
  );
}
